import { render } from "./PortfolioView.vue?vue&type=template&id=39d669bc&scoped=true"
import script from "./PortfolioView.vue?vue&type=script&lang=js"
export * from "./PortfolioView.vue?vue&type=script&lang=js"

import "./PortfolioView.vue?vue&type=style&index=0&id=39d669bc&lang=scss&scoped=true"

import exportComponent from "E:\\Fadi\\Projects\\Vuejs\\my-protfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d669bc"]])

export default __exports__